// rtr  = false;
require([
	'jquery'
	,
	'GoogleAnalytics'
	,
	'backbone'
	,
	'jquery_dfp'
	,
	'EventEmitter'
	,
	'pace'
	,
	'async'
	,
	'cols'
	,
	'part'
	,
	'body'
	,
	'main_head'
	,
	'main_navi'
	,
	'main_link'
	,
	'main_cell'
	,
	'main_line'
	,
	'main_nets'
	,
	'main_info'
	,
	'main_foot'
	,
	'main_page'
	,
	'lazysizes'
	,
	'ls_respimg'
	,
	'ls_bgset'
	,
	'owl_slider'
	,
	'owl_slider_navigation'
	,
	'owl_slider_autoplay'
	,
	// 'dotdotdot'
	// ,
	// 'moment'
	// ,
	// 'hbs'
	// ,
	// 'select2'
	// ,
	// 'slick_carousel'
	// ,
	// 'd3'
	// ,
	// 'jquery-dimensions'
	// ,
	// 'jquery-mousewheel'
	// ,
	// 'bootstrap-toolkit'
	// ,
	// 'ScrollMagic'
	// ,
	// 'TweenLite'
	// ,
	// 'TweenMax'
	// ,
	// 'TimelineMax'
	// ,
	// ,
	// 'debug.addIndicators'
	// ,
	// 'animation.gsap'
	// ,
	'bootstrap_transition'
	,
	'bootstrap_modal'
	,
	'bootstrap_alert'
	,
	'pag_base'
	,
	'pag_home'
	,
	'pag_single'
	,
	'pag_section'
	// ,
	// '../jsc/site/page/pag_sect'
	// 'pag_section'
	// ,
	// '../jsc/site/page/pag_find'
	// ,
	// '../jsc/site/page/pag_sect'
	// 'owlcarousel',
	// '../jsc/site/page/pag_quienes_somos',
	// '../jsc/site/page/pag_oportunidades',
	// '../jsc/site/page/pag_oferentes',
	// '../jsc/site/page/pag_oferente',
	// '../jsc/site/page/pag_categoria',
	// 'YouTubePlayer',
	// 'hbs',
	// 'underscore',
	// '../jsc/site/page/pag_user_oportunidades',
	// '../jsc/site/page/pag_user_entra',
	// '../jsc/site/page/pag_pass_email',
	// '../jsc/site/page/pag_pass_reset',
	// '../jsc/site/page/pag_error_500',
	// '../jsc/site/page/pag_error_404',
	// '../jsc/site/page/pag_error_401',
	// '../jsc/site/page/pag_oportunidad',
	// '../jsc/site/page/pag_user_nuevo',
	// '../jsc/site/page/pag_user_edita',
	// '../jsc/site/page/pag_joven',
	// 'bootstrap_affix',
	// 'bootstrap_button',
	// 'bootstrap_carousel',
	// 'bootstrap_popover',
	// 'bootstrap_scrollspy',
	// 'bootstrap_tab',
	// 'bootstrap_tooltip',
]
,
function (
	jquery
	,
	GoogleAnalytics
	,
	Backbone
	,
	jquery_dfp
	,
	EventEmitter
	,
	Pace
	,
	async
	,
	Cols
	,
	Part
	,
	Body
	,
	mainHead
	,
	mainNavi
	,
	mainLink
	,
	mainCell
	,
	mainLine
	,
	mainNets
	,
	mainInfo
	,
	mainFoot
	,
	mainPage
	,
	lazySizes
	,
	respImg
	,
	bgSet
	,
	owl_slider
	,
	owl_slider_navigation
	,
	owl_slider_autoplay
	// ,
	// // ,
	// // dotdotdot
	// // ,
	// // moment
	// // ,
	// // hbs
	// // ,
	// // select2
	// // ,
	// // slick_carousel
	// // ,
	// // d3
	// // ,
	// // dimensions
	// // ,
	// // jquery_mousewheel
	// // ,
	// // bootstrapToolkit
	// // ,
	// // ScrollMagic
	// // ,
	// // TweenLite
	// // ,
	// // TweenMax
	// // ,
	// // TimelineMax
){

	// console.log('window.jQuery.fn.jquery: '+window.jQuery.fn.jquery);
	//--

	if(typeof GoogleAnalytics != 'undefined')
	{
		GoogleAnalytics.ready(function (ga) {
			// GA is fully loaded
			// console.log('Analytics');
			// console.log(ga);

		});
	}

	var bodyView = new Body({
		el: document.body
	});

	/*
	 * Router principal - Toma la URI del Evento pushState
	 * y la pasa al collection principal.
	 *
	 * Nada escondido
	**/
	Router = Backbone.Router.extend({

		/*
		 * Una ruta para rutearlas a todas \m/
		**/
		routes : {
			'*path' : 'delegateRequest'
		}

		/*
		 * Instanciando uno y solo uno 'main-collection'.
		**/
		,
		collection : new Cols({
			reset : false
		})

		/*
		 * Scroleando al top, se envía el evento para manejar
		 * las transiciones CSS de la página y reconstruya el
		 * 'main-collection'.
		**/
		, delegateRequest : function delegateRequest(_path) {
			var that = this;

			// console.info('1.UI.mainViewPending '+_path);
			// // window.scrollTo(0, 1);
			// $(window).stop(true).scrollTo($('.main_menu'), {offset: {top: -($('.main_menu').height()+32)}, duration:400, interrupt:true, onAfter: function(){
			// }});
			// window.scrollTo(0, 1);
			bodyView.trigger('UI.mainViewPending');
			$.fancybox.showLoading();

			//-- 
			$.fancybox.helpers.overlay.open({ 
				  parent: $('.main_page, .main_line, .main_menu .navbar-home .menu-inferior .container')
				, closeClick : false
				, css: {
						  'background-color': '#FFFFFF'
						, opacity: 0.50
						, speedIn: 400
						, speedOut: 400
						, 'background-image': 'none' 
					}
			});

			/*
			 * Al hacer 'fetch' se toma la 'data' y el 'type'
			 * con lo que se trabaja la plantilla a cargar en 
			 * el el 'collection' cols.js
			*/

			//-- 
			// var model = this.collection.get(type);
			// console.log('model: '+model);

			//-- 
			// this.collection.url = _path || '/';
			this.collection.url = (_path ? '/'+_path : _path) || '/';
			this.collection.fetch({
				// success : $.proxy(function(res){
				// 	// console.dir(res);
				// 	// this.applyBodyClass();
				// }, this),

				complete: 
				function(xhrobj, status){
					// console.info('xhrobj.status:');
					// console.log(xhrobj.status);

					// console.log(xhrobj);

					switch(xhrobj.status)
					{

						case 200:
							// console.info('arguments');
							// console.log(arguments);
							// console.info('response:');
							// console.info(xhrobj);
							console.log('Status: '+status);

							$(window).stop(true).scrollTo($('.main_menu'), {offset: {top: 0}, duration:400, interrupt:true, onAfter: function(){
								//-- console.log('termina');
								$.proxy(this.applyBodyClass, this);
							}});

						break;
						case 401:
							//-- 
							modalo = $('.modal_noauth');
							//-- 
							modalo.modal({'backdrop': 'static', 'keyboard': false});
							//--
							header = xhrobj.responseJSON.page.page.name;
							//-- 
							results_area = modalo;

							//-- 
							//-- CALLBACKS
							//-- 
							modalo
							.on('show.bs.modal', function (){
								//-- 
							})
							.on('hide.bs.modal', function (){
								//-- 
								modalo.find('.page_head_area .page_head').text('...');
							})
							//-- MOSTRADO
							.on('shown.bs.modal', function () {
								//-- 
								modalo.find('.page_head_area .page_head').text(header);
							})
							//-- OCULTADO
							.on('hidden.bs.modal', function () {
							});


							//-- 
							var msg = false;
							//-- 
							modalo.find('.alert_area:eq(0) .alert')
							.removeClass('hidden alert-danger alert-clean alert-warning')
							.find('.msg_area .msg')
							.empty();

							//-- 
							// $(window).stop(true).scrollTo(results_area, {offset: {top:-results_area.height()}, duration:200, interrupt:true, onAfter: function(){

								$.fancybox.helpers.overlay.close();
								$.fancybox.hideLoading();

								msg = $('<div/>', {
									id : 'err',
									html : xhrobj.responseJSON.page.page.message
								});
								//-- 
								modalo.find('.alert_area:eq(0) .alert')
								.removeClass('hidden alert-danger alert-clean alert-warning')
								.addClass('alert-warning')
								.find('.msg_area .msg')
								.append(msg);

								if(xhrobj.responseJSON.path){
									var cycle = null;
									var msecs = xhrobj.responseJSON.path.time;
									var count = 0;
									var limit = msecs/1000;

									if(xhrobj.responseJSON.path.time && xhrobj.responseJSON.path.time)
									{
										//-- 
										setTimeout(function(){ execute(); }, msecs);
										//-- 
										cycle = setInterval(function(){
											++count;
											$('.time').html(limit-count);
										}, 1000);
									}
									else{
										execute();
									}

									function execute(){
										clearInterval(cycle);
										modalo
										.modal('hide')
										.off('hidden.bs.modal')
										.on('hidden.bs.modal', function () {

											//-- 
											if(xhrobj.responseJSON.path){
												if(xhrobj.responseJSON.path == 'refresh'){
													Backbone.history.loadUrl(Backbone.history.getFragment());
												}
												else{
													if( xhrobj.responseJSON.path.path=='/' || Backbone.history.getFragment() == xhrobj.responseJSON.path.path){
														// console.log(Backbone.history.getFragment());
														Backbone.history.loadUrl(Backbone.history.getFragment());
													}
													else{
														window.rtr.navigate(xhrobj.responseJSON.path.path, { trigger: true });
													}
												}
												//-- 
												if (!('pushState' in window.history)) {
													return true;
												}
											}
										});
									}
								}
							// }});
						break;
						case 404:
							// console.info('arguments');
							// console.log(arguments);
							that.collection.assignViews.apply(that.collection, [false, false, {xhr: xhrobj}]);
							that.applyBodyClass.call(that);
						break;
						case 301:
							// console.info('arguments');
							// console.log(arguments);

							$(window).stop(true).scrollTo($('.main_menu'), {offset: {top: 0}, duration:400, interrupt:true, onAfter: function(){
								that.collection.assignViews.apply(that.collection, [false, false, {xhr: xhrobj}]);
								that.applyBodyClass.call(that);
							}});
						break;
						case 501:
							// console.info('arguments');
							// console.log(arguments);

							$(window).stop(true).scrollTo($('.main_menu'), {offset: {top: 0}, duration:400, interrupt:true, onAfter: function(){
								that.collection.assignViews.apply(that.collection, [false, false, {xhr: xhrobj}]);
								that.applyBodyClass.call(that);
							}});
						break;
						default:
							console.log('Status no definido');
							// console.info('arguments');
							// console.log(arguments);

							$(window).stop(true).scrollTo($('.main_menu'), {offset: {top: 0}, duration:400, interrupt:true, onAfter: function(){
								that.collection.assignViews.apply(that.collection, [false, false, {xhr: xhrobj}]);
								that.applyBodyClass.call(that);
							}});
						break;
					}
				}
			});

		}

		/*
		 * Primer evento que emite la señalización para
		 * cuando la carga es finalizada.
		**/
		, applyBodyClass : function (ele) {
			//-- Cerrando Overlay
			// $.fancybox.helpers.overlay.close();
			// console.log('2.UI.mainViewReady');
			bodyView.trigger('UI.mainViewReady');
			// Even.init();
		}

	});

	//--
	var path = requirejs.s.contexts._.config.baseUrl+'site/page/';
	// var page = $('.page_base').attr('data-page');
	var page = $('.page_base').attr('data-page');
	page = 'pag_'+page+'';
	// var base = 'base';
	var base = 'base';
	base = 'pag_'+base+'';
	//--
	require
	([
		// '../jsc/site/page/pag_'+base+''
		base
		,
		page
		// '../jsc/site/page/pag_'+page+'?noext',
		// path + 'pag_' + base + '.js',
		// path + 'pag_' + page + '.js'
	]
	,
	function ( Base, Page )
	{
		//--
		// console.log('Cargando... : '+base);
		//--
		Base.init();
		//--
		// console.log('Cargando... : '+page);
		//--
		Page.init();
	});

	// (Site[pag] === undefined ? function(){ console.log(pag+': '+'No hay función definida'); } : Site[pag])();

	/**
	* Instancia actual de la aplicación.
	**/
	window.rtr      = new Router();

	/**
	 * Ejecutando Backbone-history con manejador de pushState.
	 **/
	Backbone.history.start({
		  pushState: true
		, hashChange: true
		, silent: true
	});

	/**
	 * Enlazando todos los eventos al dar click.
	 *
	 * Si un navegador no soporta la ruta externa invocada con
	 * el API HTML5-pushState, la función es abortada.
	 * Caso contrario la instancdia del enrutador es ejecutada con la URI.
	 **/
	// $(document.body).on('click', '.main_menu .navbar-home .menu-inferior a', function (event) {
	// 	var disparador = $(this).parent().hasClass('menu-item') == true;
	// 	// console.log('this.pathname: '+this.pathname);
	// 	// base.test(this.href) && rtr.navigate(this.pathname, { trigger: disparador });
	// 	base.test(this.href) && rtr.navigate(this.pathname, { trigger: disparador });
	// 	//--
	// 	// console.log('Click on a Link');
	// 	if (!('pushState' in window.history) || /^\/(wp-login|wp-admin)/.test(this.pathname)) {
	// 		return true;
	// 	}
	// 	event.preventDefault();
	// });
	// $(document.body).on('click', 'a.ps', function (item) {

	// 	if($(this).parent().hasClass('social')){
	// 		// window.location = this.href;
	// 		// window.open( this.href, '_blank');
	// 		// console.log(this.href.replace(base, ''));

	// 		window.open( this.href, '_blank');
	// 		return false;
	// 	}

	// 	/**
	// 	* Expresion que identifica URIs internas.
	// 	**/
	// 	var base = new RegExp('^' + window.BB.base_url);

	// 	console.log('this.pathname: '+this.pathname);
	// 	// console.log('this.pathname: '+this.href.replace(base, ''));
	// 	base.test(this.href) && rtr.navigate(this.href.replace(base, ''), { trigger: true });
	// 	//--
	// 	if (!('pushState' in window.history) || /^\/(wp-login|wp-admin)/.test(this.pathname)) {
	// 		return true;
	// 	}
	// 	item.preventDefault();
	// });


});

requirejs.onError = function (err) {
    console.error(err.requireType);
    if (err.requireType === 'timeout') {
        console.error('Error on modules: ' + err.requireModules);
    }

    throw err;
};
define("boot", function(){});

